import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

/**
 * Delete depots
 *
 * @private
 */
export const deleteDepots = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  string[],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/depot/delete', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/depot/delete', {
      category: 'rpc',
      type: 'rpc/depot/delete',
      ids: payload,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {deleteDepots}`,
      { tags: ['rpc', 'depots'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Delete depots failed`,
      error,
    })
  }
})
